import {
  Box,
  Flex,
  Tag,
  TagCloseButton,
  TagLabel,
  TagProps,
} from '@chakra-ui/react';
import Button from '~/components/Button';
import Input from '~/components/Input';

import { Tags } from './TagSelect.types';

interface Props {
  maxCharacters?: number;
  maxTags?: number;
  onChange: (event: React.FormEvent<HTMLInputElement>) => void;
  onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onRemove: (tag: string) => void;
  onSubmit: () => void;
  tagProps: TagProps;
  tags: Tags;
  textInputPlaceholder?: string;
  textSubmitButton?: string;
  value: string;
}

export const TagSelectComponent: React.FC<Props> = ({
  maxCharacters = 15,
  onChange,
  onKeyDown,
  onRemove,
  onSubmit,
  tagProps,
  tags,
  textInputPlaceholder = 'Create your own',
  textSubmitButton = 'Add Tag',
  value,
}) => (
  <Box minHeight="100px">
    <Flex alignItems="center" marginBottom={4}>
      <Input
        data-testid="tag-select-input"
        value={value}
        flex={1}
        marginRight={4}
        maxLength={maxCharacters}
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder={textInputPlaceholder}
      />

      <Button
        color={!value.length ? 'primary.200' : 'primary.500'}
        type="button"
        isDisabled={!value.length}
        onClick={onSubmit}
        variant="link"
      >
        {textSubmitButton}
      </Button>
    </Flex>

    <Flex flexWrap="wrap" marginX={-1}>
      {tags.map((tag) => (
        <Tag
          borderRadius="full"
          colorScheme="primary"
          key={tag}
          marginX={1}
          marginBottom={2}
          paddingX={4}
          size="lg"
          variant="outline"
          data-testid={tag}
          {...tagProps}
        >
          <TagLabel>{tag}</TagLabel>
          <TagCloseButton
            data-testid={`remove-${tag}`}
            onClick={() => onRemove(tag)}
            opacity={1}
            sx={{ svg: { width: 4, height: 4 } }}
          />
        </Tag>
      ))}
    </Flex>
  </Box>
);
